import { apiClient } from './api';
import { OccupancySummaryResponse } from '../types/occupancy';

/**
 * Service for the occupancy rate endpoint.
 * GET /api/v1/admin/occupancy — read-only, no withConflictRetry needed.
 */
export const occupancyService = {
  /**
   * Fetches the occupancy summary for the current owner.
   * Optionally filters to a single apartment by ID.
   */
  async getOccupancy(apartmentId?: string): Promise<OccupancySummaryResponse> {
    const params: Record<string, string> = {};
    if (apartmentId) {
      params.apartmentId = apartmentId;
    }
    const response = await apiClient.get<OccupancySummaryResponse>(
      '/admin/occupancy',
      { params },
    );
    return response.data;
  },
};
